/* eslint-disable */

export const protobufPackage = "squareup.authz_engines";
export let PolicyProtectedAction = /*#__PURE__*/function (PolicyProtectedAction) {
  PolicyProtectedAction[PolicyProtectedAction["ACTION_UNSPECIFIED"] = 0] = "ACTION_UNSPECIFIED";
  PolicyProtectedAction[PolicyProtectedAction["LINK_DEBIT_CARD"] = 1] = "LINK_DEBIT_CARD";
  PolicyProtectedAction[PolicyProtectedAction["CREATE_SQUARE_CHECKING_ACCOUNT"] = 2] = "CREATE_SQUARE_CHECKING_ACCOUNT";
  PolicyProtectedAction[PolicyProtectedAction["ORDER_SQUARE_DEBIT_CARD"] = 3] = "ORDER_SQUARE_DEBIT_CARD";
  PolicyProtectedAction[PolicyProtectedAction["CREATE_ACH_TRANSFER"] = 4] = "CREATE_ACH_TRANSFER";
  PolicyProtectedAction[PolicyProtectedAction["SCA_ACTION"] = 5] = "SCA_ACTION";
  PolicyProtectedAction[PolicyProtectedAction["SCA_VERIFICATION_ATTEMPT"] = 6] = "SCA_VERIFICATION_ATTEMPT";
  PolicyProtectedAction[PolicyProtectedAction["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
  return PolicyProtectedAction;
}({});
export let DenyCause = /*#__PURE__*/function (DenyCause) {
  DenyCause[DenyCause["UNKNOWN"] = 0] = "UNKNOWN";
  DenyCause[DenyCause["UNAUTHENTICATED"] = 1] = "UNAUTHENTICATED";
  DenyCause[DenyCause["INSUFFICIENT_PERMISSIONS"] = 2] = "INSUFFICIENT_PERMISSIONS";
  DenyCause[DenyCause["INSUFFICIENT_AUTHENTICATION"] = 3] = "INSUFFICIENT_AUTHENTICATION";
  DenyCause[DenyCause["SCA_ATTEMPTS_EXCEEDED_LIMIT"] = 4] = "SCA_ATTEMPTS_EXCEEDED_LIMIT";
  DenyCause[DenyCause["BLOCKED_BY_RISK"] = 5] = "BLOCKED_BY_RISK";
  DenyCause[DenyCause["ACH_AMOUNT_EXCEEDED_LIMIT"] = 6] = "ACH_AMOUNT_EXCEEDED_LIMIT";
  DenyCause[DenyCause["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
  return DenyCause;
}({});

/** Add data as needed here */

/**
 * We want one top-level object that holds internal action-scoped objects. Even
 * in a world where we store common data in (or otherwise immediately accessible to) AuthzEngines,
 * there will likely always be some request contextual data used for evaluations that
 * make sense for the client to provide. Ideally as we get closer to that world, the size
 * and complexity of this request object shrinks.
 */